/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 7/1/22
 */
import React, {createContext, useContext, useState, useEffect, useCallback} from 'react';

const AuditDataContext = createContext({
  currentAudit: null,
  setCurrentAudit: val => val,
  dataIntro: [],
  setDataIntro: val => val,
  dataIntroIndexed: [],
  setDataIntroIndexed: val => val,
  dataSections: [],
  setDataSections: val => val,
  dataSectionsIndexed: [],
  setDataSectionsIndexed: val => val,
  saving: false,
  setSaving: val => val,
  getSectionData: ({section, answer, issue}) => ({section, answer, issue})
});

const useAuditData = () => {
  const context = useContext(AuditDataContext);
  if (context === undefined) {
    throw new Error('useAuditData must be used within a AuditDataProvider');
  }

  return context;
};

const URL = 'https://ip.nf/me.json';

const AuditDataProvider = ({ ...props }) => {

  const [currentAudit, setCurrentAudit] = useState(null);
  const [dataIntro, setDataIntro] = useState([]);
  const [dataIntroIndexed, setDataIntroIndexed] = useState([]);
  const [dataSections, setDataSections] = useState([]);
  const [dataSectionsIndexed, setDataSectionsIndexed] = useState([]);
  const [dataContacts, setDataContacts] = useState([]);
  const [dataContactsIndexed, setDataContactsIndexed] = useState([]);
  const [locationData, setLocationData] = useState('');
  const [saving, setSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      // eslint-disable-next-line no-undef
      await fetch(URL)
        .then((res) => res?.json())
        .then(result => setLocationData(`${result?.ip?.city}, ${result?.ip?.country}`))
        .catch();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }

  };

  useEffect(() => {
    fetchData()?.then();
  }, []);

  const getSectionData = useCallback((ids) => {
    const section = dataIntro?.concat(dataSections)?.concat(dataContacts)?.find((s) => s?._id === ids?.section);
    const answer = section?.questions?.find((q) => q?._id === ids?.answer);
    const issue = answer?.issues?.find((i) => i?._id === ids?.issue);
    return { section, answer, issue };
  }, [dataIntro, dataSections, dataContacts]);

  return (
    <AuditDataContext.Provider
      value={{
        currentAudit,
        setCurrentAudit,
        dataIntro,
        setDataIntro,
        dataIntroIndexed,
        setDataIntroIndexed,
        dataSections,
        setDataSections,
        dataSectionsIndexed,
        setDataSectionsIndexed,
        dataContacts,
        setDataContacts,
        dataContactsIndexed,
        setDataContactsIndexed,
        locationData,
        setLocationData,
        saving,
        setSaving,
        getSectionData,
        isLoading
      }}
      {...props}
    />
  );
};

export { useAuditData, AuditDataProvider };

